import { __assign } from "tslib";
import React from 'react';
import Specification from './specification/specification';
import { pluralise } from '@at/formatter-utils';
/**
 * @deprecated Use Specification component instead
 */
export var SpecificationList = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var spec = _a.spec;
    var findSpecFromArray = Array.isArray(spec)
        ? function (category) {
            var _a;
            return (_a = spec.find(function (item) { return item.category === category; })) === null || _a === void 0 ? void 0 : _a.label;
        }
        : function () { return undefined; };
    var findSpecFromAny = function (category) {
        return spec[category] || findSpecFromArray(category);
    };
    var seatsString = findSpecFromAny('seats');
    var seatsNumber = Number(seatsString);
    var seats = seatsNumber ? "".concat(seatsString, " ").concat(pluralise('seat', seatsNumber)) : seatsString === null || seatsString === void 0 ? void 0 : seatsString.toString();
    var doorsString = findSpecFromAny('doors');
    var doorsNumber = Number(doorsString);
    var doors = doorsNumber ? "".concat(doorsString, " ").concat(pluralise('door', doorsNumber)) : doorsString === null || doorsString === void 0 ? void 0 : doorsString.toString();
    var specification = {
        seats: seats,
        doors: doors,
        bodyType: (_b = findSpecFromAny('bodyType')) === null || _b === void 0 ? void 0 : _b.toString(),
        fuelType: (_c = findSpecFromAny('fuel')) === null || _c === void 0 ? void 0 : _c.toString(),
        transmission: (_d = findSpecFromAny('transmission')) === null || _d === void 0 ? void 0 : _d.toString(),
    };
    if (spec.fuel === 'Electric') {
        specification.batteryRange = ((_f = (_e = spec.battery) === null || _e === void 0 ? void 0 : _e.range) === null || _f === void 0 ? void 0 : _f.range)
            ? "".concat((_h = (_g = spec.battery) === null || _g === void 0 ? void 0 : _g.range) === null || _h === void 0 ? void 0 : _h.range, " ").concat((_k = (_j = spec.battery) === null || _j === void 0 ? void 0 : _j.range) === null || _k === void 0 ? void 0 : _k.unit)
            : (_l = findSpecFromArray('batteryRange')) === null || _l === void 0 ? void 0 : _l.toString();
    }
    else {
        specification.engineSize = ((_m = spec.techData) === null || _m === void 0 ? void 0 : _m.badgeEngineSize) || ((_o = findSpecFromArray('badgeEngineSize')) === null || _o === void 0 ? void 0 : _o.toString());
    }
    return React.createElement(Specification, __assign({}, specification));
};
